<div class="app-modal">
  @if (!dynamicResponse) {
    <div mat-dialog-title class="content-align">
      {{ actionConfig.popUpTitle }}
    </div>
  }
  @if (actionConfig) {
    <div mat-dialog-content>
      @if (step == 0 && !dynamicResponse) {
        <div>
          <div class="content-align">{{ actionConfig.popUpDescription }}</div>
          @if (formGroup) {
            <table [formGroup]="formGroup">
              @for (field of fieldsToDisplay; track field) {
                <tr [ngClass]="{ disabled: field.editReadOnly }">
                  @if (field.help) {
                    <button mat-icon-button color="primary" [matTooltip]="field.help">
                      <mat-icon class="tooltip-icon">help</mat-icon>
                    </button>
                  }
                  @if (!field.formFullWidth && !field.noLabel) {
                    <td>{{ field.label }}</td>
                  }
                  <td [style]="transform(field.tableCss)" [attr.colspan]="field.formFullWidth ? 2 : 1">
                    <app-form-field
                      [type]="field.type"
                      [fieldConfig]="field"
                      [editMode]="true"
                      [formGroup]="formGroup"
                      [rowData]="entityData"
                      [data]="formGroup.get(field.name)?.value"
                      [attr.data-id]="'fieldName_' + field.name"></app-form-field>
                  </td>
                </tr>
              }
            </table>
          }
        </div>
      }
      @if (step == 1 && !dynamicResponse) {
        <div class="content-align">
          <div class="content-bottom">{{ actionConfig.confirmationMessage }}</div>
          @for (field of confirmationFields; track field) {
            <app-form-field
              class="form-field"
              [type]="field.type"
              [fieldConfig]="field"
              [editMode]="false"
              [formGroup]="formGroup"
              [rowData]="entityData"
              [data]="formGroup.get(field.name)?.value"></app-form-field>
          }
        </div>
      }
      @if (step == 1 && confirmationFormFields) {
        <div>
          @if (doubleCheckFormGroup) {
            <table class="full-width-content" [formGroup]="doubleCheckFormGroup">
              @for (field of confirmationFormFields; track field) {
                <tr [ngClass]="{ disabled: true }">
                  @if (!field.formFullWidth && !field.noLabel) {
                    <td>{{ field.label }}</td>
                  }
                  <td
                    [style]="transform(field.tableCss)"
                    class="content-align-left"
                    [attr.colspan]="field.formFullWidth ? 2 : 1">
                    <app-form-field
                      [type]="field.type"
                      [fieldConfig]="field"
                      [editMode]="false"
                      [formGroup]="doubleCheckFormGroup"
                      [rowData]="entityData"
                      [data]="doubleCheckFormGroup.get(field.name)?.value"></app-form-field>
                  </td>
                </tr>
              }
            </table>
          }
        </div>
      }
      @if (step == 2 && summaryObject) {
        <div class="content-adjust">
          @for (entry of summaryObject; track entry) {
            <div class="content-bottom">
              <b>{{ entry.key }}: </b>
              <span data-id="summary">{{ entry.value }}</span>
            </div>
          }
        </div>
      }
      @if (dynamicResponse) {
        <div class="content-align">
          <div>
            <b>{{ dynamicResponse.message }}</b>
          </div>
          <div>
            {{ dynamicResponse.copyableMessage }}
            <button mat-icon-button (click)="copyValue()"><mat-icon>file_copy</mat-icon></button>
          </div>
        </div>
      }
    </div>
  }
  @if (!loading && !dynamicResponse && step < 2) {
    <div mat-dialog-actions class="action-buttons">
      @if (step > 0) {
        <button mat-raised-button (click)="step = step - 1" data-id="dialogBackBtn">Back</button>
      }
      <button
        mat-raised-button
        [color]="'primary'"
        (click)="yes()"
        [disabled]="formGroup && !formGroup.valid"
        data-id="dialogProceedBtn">
        Proceed
      </button>
      @if (step === 0) {
        <button mat-raised-button [color]="'warn'" (click)="no()" data-id="dialogCancelBtn">Cancel</button>
      }
    </div>
  }
  @if (!loading && dynamicResponse) {
    <div mat-dialog-actions class="action-buttons">
      @if (step === 0) {
        <button mat-raised-button [color]="'primary'" (click)="no()" data-id="dialogDismissBtn">Dismiss</button>
      }
    </div>
  }
  @if (step == 2) {
    <div mat-dialog-actions class="action-buttons">
      <button mat-raised-button [color]="'primary'" (click)="no()" data-id="dialogDoneBtn">Done</button>
    </div>
  }
  @if (loading) {
    <div class="action-buttons">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }
</div>
